import { deleteTaskService } from 'owa-todo-service';
import { getTodoCache } from '../todoCache';

export function deleteTodo(id: string) {
    getTodoCache().deleteItem(id);
    deleteTaskService(id);
}
